<card class="overview-card" [config]="cardConfig">
  <div body>
    <div
      class="overview-card--header"
      (click)="onClick.emit({ event: $event, label: config.label })"
    >
      <h3
        class="OverviewCard__Title"
        data-test-id="overviewCardHeaderTitle"
        [innerHTML]="config.label"
      ></h3>
      <icon [name]="config?.icons?.chevronRight || 'chevron_right'"> </icon>
    </div>

    @if (loading) {
      <div class="overview-card--section">
        <spinner size="small" [flexCenter]="true"></spinner>
      </div>
    }

    @if (!loading && error) {
      <div class="overview-card--section">
        <p>{{ message }}</p>
      </div>
    }

    @if (!loading && groups) {
      @for (group of groups; track group) {
        <div
          class="overview-card--section"
          (click)="
            onClick.emit({
              event: $event,
              label: config.label,
              status: group.status_key,
            })
          "
        >
          <h4 class="OverviewCard__Count">
            {{ group.count || group.items.length }}
          </h4>
          <p>{{ group.status_value }}</p>
        </div>
      }
    }
  </div>
</card>
